import { useMemo } from 'react';
import { getBSCChainId } from '../utils/helpers/contract-helpers';
import { useChainId } from './useChainId';

export const useIsBSCChain = () => {
  const chainId = useChainId();
  return useMemo(() => chainId === getBSCChainId(), [chainId]);
};
